import { useEffect, useState } from 'react';
import { getServerUrl } from '../utils/getServerUrl';
import { useUniversalNavContext } from './useUniversalNavContext';
import { useQuerySession } from './useQuerySession';
export const useSidebarLinkData = () => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const [sideNavData, setSideNavData] = useState([]);
    const { data: sessionData } = useQuerySession();
    useEffect(() => {
        let apiSubscribed = true;
        async function getSidebarUrlData() {
            var _a;
            const serverUrl = getServerUrl();
            const sidebarUrl = `${serverUrl}/navigation-data/sidebar`;
            const userId = ((_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.customUserId) === null || _a === void 0 ? void 0 : _a.toString()) || '';
            try {
                const response = await fetch(sidebarUrl, {
                    headers: { 'x-customuser-id': userId },
                });
                if (!response.ok) {
                    throw new Error('Response was not OK');
                }
                if (apiSubscribed) {
                    const json = await response.json();
                    const { data } = json;
                    setSideNavData(data);
                }
            }
            catch (error) {
                if (apiSubscribed) {
                    setSideNavData([]);
                }
            }
        }
        getSidebarUrlData();
        return () => {
            apiSubscribed = false;
        };
    }, [getFullyQualifiedURL, sessionData]);
    return { sideNavData };
};
//# sourceMappingURL=useSidebarLinkData.js.map
// @zapier/universal-layout@8.3.1 (41acce620)
